import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import cx from 'classnames';
import _ from 'lodash';

import { Accordion, Button, Form, FormControl, FormGroup, FormText, InputGroup, Card, Col } from "react-bootstrap";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faCreditCard, faPencilRuler, faPencilAlt } from '@fortawesome/free-solid-svg-icons';

import { updateAdvanceSettings } from 'actions/application';

import styles from './components.module.scss';
import { faCircle, faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import moment from 'moment';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default function AdvancedSettings({onNDAToggle, nda, source, onNDAChange}) {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);

  const application = useSelector((state) => _.get(state, 'application'));
  const settings = useSelector((state) => _.get(state, 'application.settings'));
  const canDownload = useSelector((state) => _.get(state, 'application.settings.canDownload'));
  const downloadEditable =_.get(settings, 'downloadEditable');

  const handleChange = (change) => {
    const updated = {
      ...settings,
      ...change
    }

    dispatch(updateAdvanceSettings(updated));
  }

  useEffect(() => {
    if(nda != null){
      handleChange({
        nda: nda.id
      })
    }
  }, [nda]); 

  return (
    <div className={styles.advanceSettings} onSelect={(e) => {
      setExpanded(e != null);
    }}>
        <div className={styles.body}>
          <PropertySwitch
            title='Allow recipients to download'
            id='canDownload'
            value={_.get(settings, 'canDownload', true)}
            onChange={(value) => {
              handleChange({
                canDownload: value
              })
            }}
          />

          {canDownload &&
            <div className={styles.downloadOptions}>
              <div className={styles.options}>
                <div className={styles.option} onClick={() => handleChange({downloadEditable : true})}>
                  <FontAwesomeIcon icon={downloadEditable ? faCheckCircle : faCircle} size="sm" color="#E51058" />
                  <label>Editable</label>
                </div>
                <div className={styles.option} onClick={() => handleChange({downloadEditable : false})}>
                  <FontAwesomeIcon icon={downloadEditable ? faCircle: faCheckCircle}  size="sm" color="#E51058" />
                  <label>Read Only</label>
                </div>
              </div>
              <div className={styles.help}>*This applies to PPTs, Docs, Google Slides and Google Docs.</div>
            </div>
          }

          <PropertySwitch
            title='Allow recipients to reshare'
            id='canReshare'
            value={_.get(settings, 'canReshare', true)}
            onChange={(value) => {
              handleChange({
                canReshare: value
              })
            }}
          />

          <PropertySwitch
            title='Enable NDA'
            id={`enableNDA_${new Date().getTime()}`}
            value={nda != null ? true : false}
            onChange={() => {
              onNDAToggle();
            }}
          />

          {nda &&
            <div className={styles.nda}>
              <span className={styles.name}>
                {nda.name}
              </span>

              <span className={styles.edit} onClick={() => { 
                onNDAChange();
              }}>
                <i className='paperflite-edit'></i><span className={styles.label}>CHANGE</span>
              </span>
            </div>
          }

          <PasswordPanel settings={settings} onPasswordChange={(change) => handleChange(change)}/>
          <ExpiryDatePanel settings={settings} onExpiryDateChange={(change) => handleChange(change)}/>

          {_.get(application,"activeCRM","") === "GMAIL" &&  <UTMParameters source={"Gmail"}/>}

        </div>
    </div>
  );
}

function UTMParameters({ source }) {
  const [expanded, setExpanded] = useState(false);
  const settings = useSelector((state) => _.get(state, 'application.settings'));

  const [state, setState] = useState({
    source: source,
    name: _.get(settings, "utmCampaign.name", ""),
    medium: _.get(settings, "utmCampaign.medium", ""),
    term: _.get(settings, "utmCampaign.term", ""),
    content: _.get(settings, "utmCampaign.content", ""),
  })
  const dispatch = useDispatch();

  useEffect(() => {

    const element = document.getElementById("accordion-container");

    if (element) {
      var scrollHeight = element.scrollHeight + 100;
      window.scrollTo({ top: scrollHeight, behavior: "smooth" });
    }


  }, [expanded])

  const handleChange = (e) => {

    const newState = {
      ...state,
      [e.target.name]: e.target.value
    }
    setState(newState)

    const updated = {
      ...settings,
      utmCampaign: {
        ...newState
      }
    }
    dispatch(updateAdvanceSettings(updated));
    
  }

  return (
    <Accordion className={styles.utmParameter} activeKey={expanded ? 'utm' : null}>
      <Accordion.Toggle as={PropertySwitch}
        title='Add additonal UTM parameters'
        id='utmParams'
        value={expanded}
        onChange={() => {
          setExpanded(!expanded)
        }}
        className={styles.heading}
        eventKey="utm">
      </Accordion.Toggle>
      {
        expanded && (
          <Accordion.Collapse eventKey="utm">
            <div id='accordion-container'>
              <PropertyInput
                title='Campaign Name:'
                name="name"
                value={_.get(state, 'name', '')}
                onChange={handleChange}
                helpText="(Ex:Autumn collection 2020, Early booking 2020, Newsletter)"
              />
              <PropertyInput
                title='Campaign Source:'
                name="source"
                value={source}
                disabled={true}
                helpText="(Ex:Facebook, Twitter, Newsletter)"
              />
              <PropertyInput
                title='Campaign Medium:'
                name="medium"
                value={_.get(state, 'medium', '')}
                onChange={handleChange}
                helpText="(Ex:Marketing, CPC, Banner, Email)"
              />
              <PropertyInput
                title='Campaign Term:'
                name="term"
                value={_.get(state, 'term', '')}
                onChange={handleChange}
                helpText="(Identify the paid keywords)"
              />
              <PropertyInput
                title='Campaign Content:'
                name="content"
                value={_.get(state, 'content', '')}
                onChange={handleChange}
                helpText="(User to differentiate ads)"
              />
            </div>
          </Accordion.Collapse>
        )
      }
    </Accordion>
  );
}

/**
 * Property Switch
 */
function PropertySwitch({ title, id, value, onChange, onClick, ...rest }) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(!value);
    }
  }

  const handleClick = (e) => {
    if(onClick) {
      onClick(e);
    }
  }

  return (
    <div className={styles.property}>
      <label className={styles.title}>{title}</label>
      <Form.Check
        type="switch"
        id={id}
        label=""
        checked={value}
        onChange={handleChange}
        onClick={handleClick}
      />
    </div>
  );
}

/**
 * Property Input
 */
function PropertyInput({ title, name, value, helpText, disabled, onChange, ...rest }) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  }

  return (
    <div className={cx(styles.property, styles.input)}>
      <FormGroup className={styles.formGroup}>
        <label>{title}</label>
        <InputGroup>
          <FormControl
            disabled={disabled}
            name={name}
            type="text"
            value={value}
            onChange={handleChange}
          />
        </InputGroup>
      </FormGroup>
      <FormText className={cx("text-muted", styles.helpText)}> {helpText} </FormText>
    </div>
  );
}

function PasswordPanel({settings, onPasswordChange}) {
  const [password, setPassword] =  useState(_.get(settings, 'password', null));
  const [show, setShow] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if(password !== null) {
      setExpanded(true);
    }
  }, []);

  useEffect(() => {
    if(password !== ""){
      onPasswordChange({
        password: password
      });
    } else {
      onPasswordChange({
        password: null
      });
    }
     
  }, [password]);

  const handlePasswordToggleChange = () => {
    if(password !== null && password !== ""){
      setExpanded(true);
    }
    else {
      setExpanded(!expanded);
    }
  }

  return(
    <Accordion className={cx(styles.accordion, styles.border, styles.passwordPanel)} key="password">
      <Accordion.Toggle as={PropertySwitch}
        title='Set a password'
        id='password'
        value={expanded}
        onChange={handlePasswordToggleChange}
        className={styles.heading}
        eventKey="password"
      >
      </Accordion.Toggle>
      <Accordion.Collapse eventKey="password">
        <Card.Body>
          <Col md={12} className={styles.noPadding}>
            <InputGroup className={cx(styles.formGroup)}>
              <FormControl
                type={show ? 'text' : 'password'}
                placeholder="Enter password"
                aria-label="Password"
                aria-describedby="basic-addon1"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <InputGroup.Prepend>
                <InputGroup.Text id="basic-addon1" onClick={() => setShow(!show)}><span className="lnr lnr-eye"></span></InputGroup.Text>
              </InputGroup.Prepend>
            </InputGroup>
         </Col>
        </Card.Body>
      </Accordion.Collapse>
    </Accordion>  
  );
}

function ExpiryDatePanel({onExpiryDateChange, settings}){
  const [date, setDate] = useState(_.get(settings, 'expiryDate', null));
  const [time, setTime] = useState(_.get(settings, 'expiryDate', null));
  const [expiryDate, setExpiryDate] = useState(_.get(settings, 'expiryDate', null));
  
  const [expanded, setExpanded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if(expiryDate !== null) {
      setExpanded(true);
    }
  }, []);


  useEffect(() => {

    if(date !== null && time !== null){
      setExpiryDate(date.hour(time.hour()).minute(time.minute()).second(0));
    } else {
      setExpiryDate(null);
    }
  }, [date, time]); 

  useEffect(() => {
    if(expiryDate === null) {
      onExpiryDateChange({
        expiryDate: null
      });
    }
    if(expiryDate && expiryDate.isBefore(moment())){
      setError('Expiry date should be greater than current date');
      return;
    }

    onExpiryDateChange({
      expiryDate: expiryDate
    });

    setError(null);
  }, [expiryDate]);
  
  const handleDateToggleChange = () => {
    if(expiryDate !== null && expiryDate !== ""){
      setExpanded(true);
    }
    else {
      setExpanded(!expanded);
    }
  }

  return(
    <Accordion className={cx(styles.accordion, styles.border, styles.expiryPanel)} key="expiryDate">
      <Accordion.Toggle as={PropertySwitch}
        title='Set an expiry date &amp; time'
        id='expiryDate'
        value={expanded}
        onChange={handleDateToggleChange}
        className={styles.heading}
        eventKey="expiryDate"
      >
      </Accordion.Toggle>
      <Accordion.Collapse eventKey="expiryDate">
        <Card.Body>
          <Col md={7} className={styles.noPadding}>
            <FormGroup className={styles.formGroup}>
              <InputGroup>
                <DatePicker
                  customInput={<FormControl type="text" inputref={ref => this.dateControl = ref}/>}
                  dateFormat="DD MMM YYYY"
                  selected={date}
                  onChange={(date) => setDate(date)}
                  minDate={moment()}
                  maxDate={moment().add(2, "year")}
                  showDisabledMonthNavigation 
                  placeholderText = "MM-DD-YYY"
                  className={styles.datePicker}
                />
                <InputGroup.Prepend>
                  <InputGroup.Text><i className="lnr lnr-calendar-full"></i></InputGroup.Text>
                </InputGroup.Prepend>
              </InputGroup>
            </FormGroup>
          </Col>
          <Col md={4} mdoffset={1} className={styles.noPadding}>
            <FormGroup className={styles.formGroup}>
              <InputGroup>
                <DatePicker
                  customInput={<FormControl type="text" inputref={ref => this.timeControl = ref}/>}
                  selected={time}
                  onChange={(time) => setTime(time)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={60}
                  timeFormat = "hh:mm A"
                  dateFormat="LT"
                  timeCaption="Time"
                  placeholderText = "HH:MM"
                  className = {styles.timePicker}
                />
                <InputGroup.Prepend>
                  <InputGroup.Text><i className="lnr lnr-hourglass"></i></InputGroup.Text>
                </InputGroup.Prepend>
              </InputGroup>
            </FormGroup>
          </Col>
        </Card.Body>
      </Accordion.Collapse>
      {error && 
        <div className={styles.error}>{error}</div>
      }
    </Accordion>
  );
}
